// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__324y6","savePackageButton":"ClientWallet_savePackageButton__5ipk7"};